import React from "react";
import { connect } from "react-redux";
import {
  cryptoTokenDecode,
  formatNumber,
  currencyFormat,
  toastMessage,
} from "./../Common/Common";
import {
  deleteTransactionDataAction,
  getAllTransactionsAction,
  getAllTransactionsActionFromAdminWithInvoice,
} from "../../actions/TransactionActions";
import { getVendorTransactionsAction } from "../../actions/VendorTransactionActions";
import { getBuyerTransactionsAction } from "../../actions/BuyerTransactionActions";
import { getSubscriptionCounterAction } from "../../actions/SubscriptionReportAction";
import { getContactsActions } from "./../../actions/UserActions";
import { Row, Col, Button } from "react-bootstrap";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box } from "@material-ui/core";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import Logo from "./../../assets/img/logo.png";
import * as code from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
import "react-data-table-component-extensions/dist/index.css";

var _ = require("lodash");

const columns = [
  {
    field: "shortName",
    headerName: "Artwork ID",
    width: 150,
    editable: false,
    renderCell: (params) => (
      <a target="_blank" href={`/#/artwork/detail/${params.row.id}`}>
        {params.row.shortName}
      </a>
    ),
  },
  {
    field: "client",
    headerName: "Client",
    width: 150,
    editable: false,
  },
  {
    field: "artist",
    headerName: "Artist",
    width: 150,
    editable: false,
  },
  {
    field: "price",
    headerName: "Total Price",
    width: 100,
    editable: false,
  },
  {
    field: "fees",
    headerName: "Fees",
    width: 100,
    editable: false,
  },
  {
    field: "deposit",
    headerName: "Deposit",
    width: 100,
    editable: false,
  },
  {
    field: "convFees",
    headerName: "Conv Fees",
    width: 100,
    editable: false,
  },
  {
    field: "tip",
    headerName: "Tip",
    width: 100,
    editable: false,
  },
  {
    field: "paid",
    headerName: "Paid",
    width: 100,
    editable: false,
  },
  {
    field: "balance",
    headerName: "Owed",
    width: 100,
    editable: false,
  },
  {
    field: "dateCreated",
    headerName: "Created",
    width: 200,
    editable: false,
  },
];

class FinanceReports extends React.Component {
  constructor(props) {
    super(props);
    let userType = cryptoTokenDecode().usertype;
    let currentType = localStorage.getItem("currentRole");
    this.state = {
      transactions: [],
      userType: userType.toUpperCase(),
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      page: 0,
      PageSize: 10,
      total: 0,
      count: 0,
    };
  }

  componentWillMount() {
    this.getTransactions();
  }

  getTransactions() {
    // this.props.getAllTransactionsAction().then(res => {
    //     this.props.getVendorTransactionsAction().then(vendorRes => {
    //         this.props.getBuyerTransactionsAction().then(buyerRes => {
    //             let transactionRes = this.props.vendorTransactions.data.concat(this.props.buyerTransactions.data);
    //             this.setState({
    //                 transactions: this.props.transactions.data.concat(transactionRes)
    //             });
    //         })
    //     })
    // })
    let data = { page: this.state.page, PageSize: this.state.PageSize };
    this.props
      .getAllTransactionsActionFromAdminWithInvoice(data)
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            transactions: res.data.data,
            total: res.data.total,
            count: res.data.count,
          });
        } else {
          this.setState({
            transactions: [],
          });
        }
        // console.log("res402", res);
      });
  }

  updateData = (key, value) => {
    // console.log("key", key);
    // console.log("value", value);
    this.setState({
      page: value,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.page !== this.state.page) {
      this.getTransactions();
    }
    if (prevState.PageSize !== this.state.PageSize) {
      // console.log("componentDidUpdate prevState.PageSize", prevState.PageSize);
      // console.log(
      //   "componentDidUpdate this.state.PageSize",
      //   this.state.PageSize
      // );
      this.getTransactions();
    }
  }

  render() {
    let rows = [];
    let transactionsData = this.state.transactions;
    for (let i = 0; i < transactionsData.length; i++) {
      let transaction = transactionsData[i];
      let feesTotal = transaction.dsd.fees
        .filter((fee) => fee.name !== "Brokerage Fee")
        .map((fee) => Number(fee.value));
      // let paymentsTotal = transaction.dsd.otherEMD.map(
      //   (payment) => payment.value
      // );

      // new payment calculation using invoice details
      // let paymentsTotal = 0;
      // let tipTotal = 0;
      // let serviceChargeTotal = 0;
      // let results = [];
      // if (transaction.invoiceData && transaction.invoiceData.length > 0) {
      //   results = transaction.invoiceData.reduce(
      //     (acc, curr) => {
      //       if (
      //         curr.invoiceType !== "DEPOSIT" &&
      //         curr.paymentStatus === "APPROVED"
      //       ) {
      //         acc["amountCharged"] =
      //           acc["amountCharged"] + Number(curr.amountCharged);
      //         if (curr.tipAmount) {
      //           acc["amountCharged"] =
      //             acc["amountCharged"] - Number(curr.tipAmount);
      //           acc["tipAmount"] = acc["tipAmount"]
      //             ? acc["tipAmount"] + Number(curr.tipAmount)
      //             : acc["tipAmount"];
      //         }
      //         if (curr.serviceCharge) {
      //           acc["amountCharged"] =
      //             acc["amountCharged"] - Number(curr.serviceCharge);
      //           acc["serviceCharge"] = acc["serviceCharge"]
      //             ? acc["serviceCharge"] + Number(curr.serviceCharge)
      //             : acc["serviceCharge"];
      //         }
      //       }
      //       return acc;
      //     },
      //     { amountCharged: 0 }
      //   );
      //   paymentsTotal = results["amountCharged"];
      //   tipTotal = results["amountCharged"];
      //   serviceChargeTotal = results["serviceCharge"];
      // }

      let paymentsTotal = 0;
      let tipTotal = 0;
      let serviceChargeTotal = 0;
      let results = {};

      if (transaction.invoiceData && transaction.invoiceData.length > 0) {
        results = transaction.invoiceData.reduce(
          (acc, curr) => {
            if (
              curr.invoiceType !== "DEPOSIT" &&
              curr.paymentStatus === "APPROVED"
            ) {
              // Add to amountCharged
              acc["amountCharged"] =
                acc["amountCharged"] + Number(curr.amountCharged);

              // Handle tips
              if (curr.tipAmount) {
                acc["tipAmount"] = acc["tipAmount"]
                  ? acc["tipAmount"] + Number(curr.tipAmount)
                  : Number(curr.tipAmount);
              }

              // Handle service charges
              if (curr.serviceCharge) {
                acc["serviceCharge"] = acc["serviceCharge"]
                  ? acc["serviceCharge"] + Number(curr.serviceCharge)
                  : Number(curr.serviceCharge);
              }
            }
            return acc;
          },
          { amountCharged: 0, tipAmount: 0, serviceCharge: 0 } // Initial values
        );

        // Calculate totals
        paymentsTotal =
          results["amountCharged"] -
          results["tipAmount"] -
          results["serviceCharge"];
        tipTotal = results["tipAmount"];
        serviceChargeTotal = results["serviceCharge"];
      }

      let date = new Date(transaction.createdDate);

      let transactionObj = {
        id: transaction._id,
        shortName: transaction.shortName,
        client: `${transaction.dsd.buyer[0].firstname} ${
          transaction.dsd.buyer[0].lastname
            ? transaction.dsd.buyer[0].lastname
            : ""
        }`,
        artist: `${transaction.dsd.listingAgents[0].firstname} ${
          transaction.dsd.listingAgents[0].lastname
        }`,
        price: transaction.dsd.fees
          ? currencyFormat(
              Number(transaction.dsd.agreedOpenPrice) + _.sum(feesTotal)
            )
          : currencyFormat(transaction.dsd.agreedOpenPrice),
        deposit: currencyFormat(transaction.dsd.emd),
        fees: currencyFormat(_.sum(feesTotal)),
        tip: currencyFormat(Number(tipTotal)),
        convFees: currencyFormat(Number(serviceChargeTotal)),
        paid: currencyFormat(
          Number(transaction.dsd.emd) + Number(paymentsTotal)
        ),
        balance: currencyFormat(
          Number(transaction.dsd.agreedOpenPrice) +
            _.sum(feesTotal) -
            Number(transaction.dsd.emd) -
            Number(paymentsTotal)
        ),
        dateCreated: date.toISOString().substring(0, 10),
      };

      rows.push(transactionObj);
    }

    return (
      <div>
        <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head">
          <Col xs="12" sm="4">
            <h4 className="title-med mt-0 pt-1">Finance Reports</h4>
          </Col>
        </Row>
        {rows.length === 0 ? (
          <div className="no-transaction">
            <div className="no-transaction-inner">
              <img src={Logo} className="no-transaction-content" alt="" />
              <h2 className="no-transaction-content">No artworks found</h2>
              <hr />
            </div>
          </div>
        ) : (
          <Box sx={{ height: 600, width: "100%" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              pageSize={this.state.PageSize}
              pagination
              paginationMode="server"
              page={this.state.page}
              rowCount={this.state.count}
              rowsPerPageOptions={[10, 20, 50, 100]}
              onPageChange={(data) => {
                // this.updateData("page", data);
                //console.log("onPageChange data", data);
                this.setState({ page: data });
              }}
              onPageSizeChange={(data) => {
                // this.updateData("page", 1);
                // this.updateData("PageSize", this.state.PageSize);
                //console.log("onPageSizeChange data", data);
                this.setState({ PageSize: data, page: 0 });
              }}
              components={{
                Toolbar: GridToolbar,
              }}
              sx={{
                ".MuiDataGrid-columnSeparator": {
                  display: "none",
                },
                "&.MuiDataGrid-root": {
                  border: "none",
                },
              }}
            />
          </Box>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transactions: state.reducer.transactions,
    isDTransDeleted: state.reducer.isDTransDeleted,
    vendorTransactions: state.reducer.vendorTransactions,
    buyerTransactions: state.reducer.buyerTransactions,
    contacts: state.reducer.contacts,
  };
};

export default connect(
  mapStateToProps,
  {
    getAllTransactionsAction,
    deleteTransactionDataAction,
    getVendorTransactionsAction,
    getBuyerTransactionsAction,
    getSubscriptionCounterAction,
    getContactsActions,
    getAllTransactionsActionFromAdminWithInvoice,
  }
)(FinanceReports);
